import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import moonbuy from "../../Assets/Projects/moonbuy.png";
import arab from "../../Assets/Projects/arab.png";
import dynamic from "../../Assets/Projects/dynamic.png";
import queue from "../../Assets/Projects/queue.webp";
import service from "../../Assets/Projects/service.png";
import simvoice from "../../Assets/Projects/simvoice.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={service}
              isBlog={false}
              title="Service Booking"
              description="Sell Services Ex :- Ac Repairing, Car Service etc this web app is like UrbanClaps. Built a responsive web application using React, .net core and as little libraries as possible, to reduce load time, and increase responsiveness. Connected to APIs using Axios to be able to grab Data From .net Core Api other relevant data to show users."
              ghLink="https://github.com/smartdusttechnologies/OnlineServiceBookingApp"
              demoLink="https://github.com/smartdusttechnologies/OnlineServiceBookingApp"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={dynamic}
              isBlog={false}
              title="Testing And Calibration Labs"
              description="Collaborated with 9 Developer to create a web application, to Make This web app. Utilized chrome web debugging tools to catch common mistakes, resulting in less bugs in the application. Developed Tree Based Configurable UI Where you can Configure Elements Under Element . Implemented Google OAuth Helped other developers quickly pick up CUI to speed up the frontend aspect of the web application. Created Database Structure And Used Dapper Framework For DAL."
              ghLink="https://github.com/smartdusttechnologies/TestingAndCalibrationLabs"
              demoLink="https://github.com/smartdusttechnologies/TestingAndCalibrationLabs"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={moonbuy}
              isBlog={false}
              title="Moonbuy.in"
              description="Learned Wordpress This Website is based On Online Store and this is multi vendor Store Integrated Payment Gateway."
              ghLink="https://github.com/rajguptah"
              demoLink="https://moonbuy.in/"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={arab}
              isBlog={false}
              title="The Arabian Sea"
              description="TheArabianSea Company Profile Website Where They Can Manage Their Website By Admin panel. Send Mail To The Admin When End User Submit Inquiry Form And I have Did this with the help of SMTP and PHP Mailer. Attractive UI Design Using Bootstrap And FontAwesome."
              ghLink="https://github.com/rajguptah"
              demoLink="https://github.com/rajguptah"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={queue}
              isBlog={false}
              title="Message Queuing POC"
              description="I have Integrated RabbitMQ in .net core Project and Made a Working POC You can find it in my github Profile or Below Link. There Is Two Console Application Where Fist Is Producer And Another Is Consumer."
              ghLink="https://github.com/rajguptaH/RabbitMQ-POC"
              // demoLink="https://www.youtube.com/watch?v=dQw4w9WgXcQ&ab_channel=RickAstley" <--------Please include a demo link here
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={simvoice}
              isBlog={false}
              title="SimVoice"
              description="SimVoice - Simple Invoice Generator allows you quickly make invoices and save them as PDF This is single Page Application and you can easily customize Invoice using Inline Editing Fields."
              ghLink="https://github.com/rajguptaH/simvoice/"
               demoLink="https://github.com/rajguptaH/simvoice/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
